import { VideoPlusIcon } from './VideoPlusIcon';

/**
 * author: Google
 * id 7C399890-F840-44F0-834E-409C1D9F1337
 * name video-plus
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-plus.svg
 * tags
 * - Video / Movie 
 */
export const VideoAddIcon = VideoPlusIcon;
export default VideoAddIcon